import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'

import {MAGICCUBESTORE} from '~common/commonModule/magicCube/vuex/index.js'

Vue.use(Vuex)
const state = {
    'errorType': 20
}
let modules = {
}

modules = Object.assign(modules, MAGICCUBESTORE)
export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters,
    modules: modules
})



// WEBPACK FOOTER //
// ./module/magicCube/src/store/index.js